import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import DateRange from "../DateRange/DateRange";
import {
  resetOnClickFilter,
  applyFilterInMyClientsTable,
} from "../../redux/actions";
import format from "date-fns/format";

const DateRangeFilter = () => {
  const dispatch = useDispatch();
  const {
    filterSaveClickColumnName,
    filterClearClickColumnName,
    filterDataOnClientTable,
  } = useSelector((state) => state.user);

  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);

  useEffect(() => {
    if (filterClearClickColumnName === "Date Range") {
      setSelectedDateRange([null, null]);
      dispatch(resetOnClickFilter());
    }
  }, [filterClearClickColumnName]);

  useEffect(() => {
    if (filterSaveClickColumnName === "Date Range") {
      let tempFilter = [...filterDataOnClientTable];
      if (selectedDateRange[0] == null) {
        tempFilter = tempFilter.filter(
          (data) => data.columnName !== "DateOpened"
        );
        dispatch(applyFilterInMyClientsTable(tempFilter));
      } else {
        let flag = 0;
        tempFilter.forEach((data) => {
          if (data.columnName === "DateOpened") {
            data.lowerLimit = format(selectedDateRange[0], "MM/dd/yyyy");
            data.upperLimit = format(selectedDateRange[1], "MM/dd/yyyy");
            flag = 1;
          }
        });
        if (flag === 0) {
          tempFilter.push({
            columnName: "DateOpened",
            lowerLimit: format(selectedDateRange[0], "MM/dd/yyyy"),
            upperLimit: format(selectedDateRange[1], "MM/dd/yyyy"),
          });
        }
        dispatch(applyFilterInMyClientsTable(tempFilter));
      }

      dispatch(resetOnClickFilter());
    }
  }, [filterSaveClickColumnName]);

  useEffect(() => {
    let dateFilterData = filterDataOnClientTable.filter(
      (data) => data.columnName === "DateOpened"
    );
    if (dateFilterData.length > 0) {
      setSelectedDateRange([
        new Date(dateFilterData[0].lowerLimit),
        new Date(dateFilterData[0].upperLimit),
      ]);
    }
  }, [filterDataOnClientTable]);

  const handleApplyClick = (dateRange) => {
    setSelectedDateRange([dateRange[0].startDate, dateRange[0].endDate]);
  };

  return (
    <div>
      <DateRange
        selectedDateRange={selectedDateRange}
        onApplyClick={handleApplyClick}
      />
    </div>
  );
};

export default DateRangeFilter;
